<template>
  <div class="small">
    <line-chart
      :chartData="prepData"
      :options="this.options"
      :height="this.height"/>
  </div>
</template>

<script>
import LineChart from "../lib/lineChart";
import { config } from "../config";

export default {
  components: {
    LineChart
  },
  data() {
    return {
      height: 200,
      first: true,
      histogram: [],
      alldata: [],
      timeFormat: config.graph.timeFormat,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true
        },
        scales: {
          xAxes: [
            {
              type: "time",
              gridLines: {
                display: true
              },
              scaleLabel: {
                display: config.graph.displayLabels,
                labelString: "Date"
              }
            }
          ],
          yAxes: [
            {
              display: true,
              gridLines: {
                display: true
              },
              scaleLabel: {
                display: config.graph.displayLabels,
                labelString: "Entries"
              }
            }
          ]
        },
        layout: {
          padding: {
            top: 0,
            bottom: 5
          }
        }
      }
    };
  },
  methods: {
    makeHistogram: function() {
      var histogram = [];
      var st = this.extent[0].getFullYear();
      var end = this.extent[1].getFullYear();
      var dist = Math.floor((end - st) / 20);
      while (st < end) {
        histogram.push({
          start: st,
          end: st + dist,
          x: new Date(st, 12),
          y: 0
        });
        st += dist;
      }
      this.histogram = histogram;
    },
    dataLoader: function(data) {
      var hist = this.histogram.slice();
      var datalen = data.length;
      while (datalen--) {
        var histlen = hist.length;
        while (histlen--) {
          if (typeof data[datalen].date_to !== "undefined") {
            var year = data[datalen].date_to.getFullYear();
          } else {
            year = 0;
          }
          if (year > hist[histlen].start && year <= hist[histlen].end) {
            hist[histlen].y++;
            histlen = 0;
          }
          if (year >= hist[histlen].end) {
            histlen = 0;
          }
        }
      }
      if (this.first) {
        this.alldata = hist;
      }
      return hist;
    }
  },

  computed: {
    prepData: function() {
      if (this.first) {
        this.makeHistogram();
        this.dataLoader(this.data);
      }
      this.makeHistogram();
      return {
        datasets: [
          {
            label: "All Data",
            backgroundColor: config.graph.color,
            data: this.alldata
          },
          {
            label: "Selected Data",
            backgroundColor: config.graph.color2,
            data: this.dataLoader(this.selectedData)
          }
        ]
      };
    }
  },
  props: {
    data: Array,
    extent: Array,
    selectedData: Array
  }
};
</script>
<style lang="less">
</style>
